<template>
  <div class="part part_about">
    <div class="title"> 
      <img src="../../static/other/line.png"/>
        <h2>应用简介</h2>
        <h2>APPLICATION INTRODUCTION</h2>
    </div>    
    <el-row>
      <el-col :xs="24" :sm="12" class="about_left">
        <div class="wrap">
          {{ intro[0].content }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" class="about_right">
        <img :src="aboutImg[0].img"/>
      </el-col>
    </el-row>
  </div> 

</template>
<script>
    export default {
        name: 'Intro',
        data () {
            return {
              intro: [
                        {
                            title: "应用简介",
                            content: "留学万象是一家专注于美国，英联邦国家及欧洲世界顶尖名校申请的研究型留学咨询服务公司。中国的留学咨询行业属于新兴行业，一直以来没有形成统一的留学咨询服务体系和质量管理体系，针对留学申请的评估量化系统也有待进一步开发，近几年来，客户服务体验差，服务质量粗糙，管理体系不健全等问题在留学行业屡见不鲜。公司的几大创始人，凭借在留学咨询行业十年从业的心得体会，经验积累，并不断改进创新，立志通过十年经验和服务经验，建立一个更好更专业的留学咨询公司，建立一个标杆式的留学服务品牌，打造中国高品质并深受客户信任的教育咨询品牌。“树立新的行业标准”是留学万象的目标，“诚信、有担当、公平正义”是留学万象的企业价值观。"
                        }
                    ],
              aboutImg:[
                {
                  img: require('../../static/other/intro.jpg')
                }
              ]
            }
        }
    }
</script>

<style scoped>
  /* 公共 */
  .part{
    margin: 100px 0 200px 0;
  }
  .title{
    text-align: center;
    margin: 120px 0;
    color: #317bcb;
  }
  .about_left{
    padding: 0% 5% 5% 25%;
  }
  .about_left ul{
    list-style: none;
    padding-left: 0;
  }
  .about_left ul li{
    text-decoration: none;
    line-height: 2em;
  }
  .about_left li img{
    margin-right: 10px;
  }
  .about_right img{
    width: 60%;
  }
    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
      .part{
        margin: 50px 0;
      }
      .title{
        margin: 0;
      }
      .about_left{
        padding: 5% 15% 5% 15%;
      }    
      .about_right img{
        width: 90%!important;
        margin-left: 5%;
      }
    }
</style>